import { render, staticRenderFns } from "./AdminAthleteAutocomplete.vue?vue&type=template&id=3b314666&"
import script from "./AdminAthleteAutocomplete.vue?vue&type=script&lang=ts&"
export * from "./AdminAthleteAutocomplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports